module.exports = __webpack_public_path__ + "assets/img/star_sentence_select2.4356ff50.png";